module.exports = __webpack_public_path__ + "media/components/country-flag/static/er-2965cbaa2e0cc9c71333d0c04847ef9a.svg";